module dg.navigation {

    export class MenuDropdownItemController {

        private title: string;
        private iconClass: string;
        private items: dg.restfulApi.Link[];
        private states: angular.ui.IState[] = [];
        private showDropdown: boolean = false;

        public constructor(private navigationService: dg.navigation.NavigationService,
            private $state: ng.ui.IStateService) {
        }

        $onChanges = (changes) => {
            if (this.items) {
                this.items.forEach(item => {
                    if (item && !item.disabledReason) {
                        this.states.push(this.navigationService.getState(item));
                        this.showDropdown = true;
                    };
                });
            }
        }

        public isActive = () => {
            let activeClass = '';
            this.states.forEach(state => {
                if (this.$state.includes(state.name)) {
                    activeClass = 'active';
                }
            })
            return activeClass;
        }
    }

    angular.module('dg.navigation')
        .component('menuDropdownItem', {
            bindings: {
                title: '@',
                iconClass: '@',
                items: '<'
            },
            controller: (MenuDropdownItemController as any),
            templateUrl: '/digmo/src/navigation/menu-dropdown-item.html'
        });
}